import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import { stringUtil } from "../../utils";
import { TextWrapper } from "./styled";

const isOverflowActive = (el) => {
  return el.offsetHeight < el.scrollHeight || el.offsetWidth < el.scrollWidth;
};

const TextOverflowWrapper = ({ children, lines, style, highlightedText, maxWidth }) => {
  const [overflowActive, setOverflowActive] = useState(false);
  const [scrollHeight, setScrollHeight] = useState();

  const [text, setText] = useState();

  useEffect(() => {
    setText(children);
  }, [children]);
  
  useEffect(() => {
    setText(stringUtil.getHighlightedText(children, highlightedText));
  }, [highlightedText]);

  const ref = useRef();

  useEffect(() => {
    setScrollHeight(ref?.current?.scrollHeight);
  }, [ref?.current?.scrollHeight]);

  return (
    <TextWrapper
      data-text={children}
      ref={ref}
      style={style}
      lines={lines}
      overflowActive={overflowActive}
      scrollHeight={scrollHeight}
      maxWidth={maxWidth}
      onMouseEnter={(e) => setOverflowActive(isOverflowActive(e.target))}>
      {text}
    </TextWrapper>
  );
};

TextOverflowWrapper.propTypes = {
  children: PropTypes.string,
  lines: PropTypes.number,
  style: PropTypes.object,
  highlightedText: PropTypes.string,
  maxWidth: PropTypes.string
};

export default TextOverflowWrapper;
